import ChartTooltip from '../../ChartTooltip';
import useSlice, { UseSlice } from './vm';

export interface SliceProps<T extends object> extends UseSlice<T> {
  color: string;
  label: string;
  tooltip: string;
  className?: string;
}

const Slice = <T extends object>({ color, label, tooltip, className, ...vmProps }: SliceProps<T>) => {
  const { sliceRef, labelRef } = useSlice(vmProps);

  return (
    <ChartTooltip title={tooltip} followCursor>
      <g className={className}>
        <path ref={sliceRef} fill={color} />
        <text
          ref={labelRef}
          dominantBaseline="middle"
          textAnchor="middle"
          fontSize={28}
          fontWeight={500}
          fill={color}
        >
          {label}
        </text>
      </g>
    </ChartTooltip>
  );
};

export default Slice;
